import type { AuditLogEvent } from '../../../domain/audit-log-event'

import { Typography } from 'antd'
import hljs from 'highlight.js/lib/core'
import json from 'highlight.js/lib/languages/json'

import { AuditLogAction } from '../../../domain/audit-log-action.enum'
import { AuditLogResourceType } from '../../../domain/audit-log-resource-type.enum'

import { CheckRunRerunExpandableRow } from './check-run-rerun-expandable-row'
import { GroupUpdateExpandableRow } from './group-update-expandable-row'

hljs.registerLanguage('json', json)

interface Props {
  auditLog: AuditLogEvent
}

export const ExpandableRow = (props: Props): JSX.Element => {
  let ExpandableRow

  if (
    props.auditLog.resource?.type === AuditLogResourceType.CheckRun &&
    props.auditLog.action === AuditLogAction.Rerun
  ) {
    ExpandableRow = CheckRunRerunExpandableRow
  } else if (
    props.auditLog.resource?.type === AuditLogResourceType.Group &&
    props.auditLog.action === AuditLogAction.Update
  ) {
    ExpandableRow = GroupUpdateExpandableRow
  } else {
    ExpandableRow = NotImplementedExpandableRow
  }

  return (
    <div className='relative !p-0'>
      <div className='absolute top-0 left-0 z-10 w-1 h-full bg-blue-200' />

      {ExpandableRow && <ExpandableRow auditLog={props.auditLog} />}
    </div>
  )
}

const NotImplementedExpandableRow = (props: Props): JSX.Element | null => {
  if (props.auditLog.resource === undefined && props.auditLog.changes === undefined) {
    return <div className='p-6'>No information</div>
  }

  const highlightedResource = hljs.highlight(JSON.stringify(props.auditLog.resource, null, 2), {
    language: 'json'
  }).value

  const highlightedChanges = hljs.highlight(JSON.stringify(props.auditLog.changes, null, 2), {
    language: 'json'
  }).value

  return (
    <div className='relative !p-0'>
      <div className='absolute top-0 left-0 z-10 w-1 h-full bg-blue-200' />

      <div className='flex flex-col gap-4 p-6'>
        {props.auditLog.resource && (
          <div>
            <Typography.Title level={4}>Resource</Typography.Title>

            <pre
              className='overflow-auto p-4 max-h-96 text-xs bg-white rounded border'
              dangerouslySetInnerHTML={{ __html: highlightedResource }}
            />
          </div>
        )}

        {props.auditLog.changes && (
          <div>
            <Typography.Title level={4}>Changes</Typography.Title>

            <pre
              className='overflow-auto p-4 max-h-96 text-xs bg-white rounded border'
              dangerouslySetInnerHTML={{ __html: highlightedChanges }}
            />
          </div>
        )}
      </div>
    </div>
  )
}
